module.exports = __webpack_public_path__ + "img/CCLF_infographic-08.d98ad182.png";